import type { FaireProductEntity } from "../../entity_types/product";

export const p_jza9nqtbws: FaireProductEntity = {
  token: "p_jza9nqtbws",
  type: "product",
  name: "Me & The Bees Prickly Pear Lemonade, 12-Pack, 12 Fl Oz Each",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Everyday Supply Co",
  imageUrl:
    "https://cdn.faire.com/fastly/b80400ec682b19e4daf445534324cbd935c5b4169111b1c8c6f2c7fa69eccd0d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f7e517b47727365beaad99edcf9f6dff2db953564c49043abef319203db9645e.jpeg",
    "https://cdn.faire.com/fastly/50545fb252fda73c0d1403c1f1fee25728aaae8f5841afc98eeb8bb691fe6e8c.jpeg",
  ],
  priceDollars: 57.89,
  description:
    "ME & THE BEES PRICKLY PEAR LEMONADE COMBINES REAL LEMON JUICE, LOCAL HONEY AND PRICKLY PEAR FOR A SWEET-TART REFRESHMENT THAT'S PERFECT FOR WARM SUMMER DAYS. NEVER MADE FROM CONCENTRATE AND FREE OF HIGH-FRUCTOSE CORN SYRUP, THIS LEMONADE HAS A FRESH, FRUITY TASTE YOU CAN FEEL GOOD ABOUT ENJOYING. THIS 12 FL. OZ. BOTTLE CONTAINS ABOUT 1-1/2 SERVINGS. A PORTION OF THE PROFITS GO TOWARD ORGANIZATIONS THAT HELP SUPPORT BEE PRESERVATION AND HEALTHY COMMUNITIES.",
  tags: [],
  msrpDollars: 83.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:44.068Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
